import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { electronApis } from '@/features/electron-api';
import { logError } from '@/lib/errorLogging';

import type { AppIconChoice } from '@electron/shared/app-icon-choice.types';

const APP_ICON_CHOICE_QUERY_KEY = ['app-icon-choice'];

export const useAppIconChoiceQuery = () =>
  useQuery({
    queryKey: APP_ICON_CHOICE_QUERY_KEY,
    queryFn: () => electronApis.system.getAppIconChoice(),
  });

export const useSetAppIconChoiceMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (icon: AppIconChoice) =>
      electronApis.system.setAppIconChoice(icon),
    onSuccess: (_, icon) =>
      queryClient.setQueryData(APP_ICON_CHOICE_QUERY_KEY, icon),
    onError: (error) => {
      logError(error, 'Changing the app icon failed');
      toast.error("The app icon couldn't be changed. Try again.");
    },
  });
};
